"use client";
import {
  Box,
  Typography,
  Container,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import AnimatedCard from "./animated-card";

export default function WhyParticipate() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography
        variant="h4"
        component="h2"
        align="center"
        gutterBottom
        fontWeight="bold"
      >
        Why Participate?
      </Typography>

      <Grid container spacing={3}>
        {[
          {
            title: "Professional Development",
            description:
              "Enhance your skills in AI integration and innovative pedagogy.",
            icon: "📚",
          },
          {
            title: "Global Collaboration",
            description:
              "Connect with educators worldwide and share diverse perspectives.",
            icon: "🌍",
          },
          {
            title: "Whitepaper Feature",
            description:
              "Chance to be featured in the official event Whitepaper.",
            icon: "📄",
          },
          {
            title: "Educators Summit",
            description: "Finalists invited to the exclusive Educators Summit.",
            icon: "🏆",
          },
          {
            title: "Shape the Future",
            description:
              "Contribute to the evolution of education in the AI era.",
            icon: "🚀",
          },
          {
            title: "Recognition",
            description:
              "Gain recognition as a thought leader in educational innovation.",
            icon: "🎓",
          },
        ].map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <AnimatedCard
              title={item.title}
              description={item.description}
              icon={item.icon}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
